import { Link } from "gatsby"
import React from 'react'
//import Places from './places';
import { Configure } from 'react-instantsearch-dom';
import MapboxPlaces from "./mapbox-places";

import Logo from '../../images/uhslogo-red.svg'

const parameters = {};

function Header() {
    
    return (
      <header className="sl_header">
        <Configure {...parameters} />
        <div className="sl_header__search">
          <Link className="sl_logo" to="/search">
            <img alt="UHS Header Logo" src={Logo}></img>
          </Link>
            <span className="algolia-places">
                <MapboxPlaces />
            </span>
          {/*<Places
          />*/}
          <a className="sl_header__talkspace" href="https://www.talkspace.com/?utm_source=uhs-findbhhelp&utm_medium=referral" target="_blank" rel="noreferrer">
            <span className="sl_header__talkspace-icon"><i className="fas fa-laptop"></i><i className="fas fa-mobile-alt"></i></span>
            Virtual Therapy via Talkspace
          </a>
        </div>{/*end sl_header__search*/}
        <a className="sl_header__talkspace-banner" href="https://www.talkspace.com/?utm_source=uhs-findbhhelp&utm_medium=referral" target="_blank" rel="noreferrer">
          <span className="sl_header__talkspace-icon"><i className="fas fa-laptop"></i><i className="fas fa-mobile-alt"></i></span>
          Virtual Therapy via Talkspace
        </a>
    </header>
    )
};

export default Header